import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';
import { DropzoneModule } from 'ngx-dropzone-wrapper';

import { RecommendationCardDialogComponent } from './components/recommendation-card-dialog/recommendation-card-dialog.component';
import { RecommendationCardComponent } from './components/recommendation-card/recommendation-card.component';
import { RecommendationsConfigurationCategoryDialogComponent } from './components/recommendations-configuration-category-dialog/recommendations-configuration-category-dialog.component';
import { RecommendationsConfigurationItemDialogComponent } from './components/recommendations-configuration-item-dialog/recommendations-configuration-item-dialog.component';
import { RecommendationsConfigurationItemComponent } from './components/recommendations-configuration-item/recommendations-configuration-item.component';
import { RecommendationsConfigurationSurveyRuleComponent } from './components/recommendations-configuration-survey-rule/recommendations-configuration-survey-rule.component';
import { RecommendationsComponent } from './components/recommendations/recommendations.component';
import { RecommendationRoutingModule, routedComponents } from './recommendation-routing.module';
import { RecommendationRestConnectorService } from './services/recommendation-rest-connector.service';
import { RecommendationService } from './services/recommendation.service';
import { RecommendationEffects, recommendationReducer } from './state';

@NgModule({
  imports: [
    StoreModule.forFeature('recommendation', recommendationReducer),
    EffectsModule.forFeature([
      RecommendationEffects,
    ]),
    CommonModule,
    RecommendationRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    DropzoneModule,
    EditorModule,
  ],
  providers: [
    RecommendationService,
    RecommendationRestConnectorService,
    RecommendationEffects,
  ],
  declarations: [
    routedComponents,
    RecommendationCardComponent,
    RecommendationsComponent,
    RecommendationCardDialogComponent,
    RecommendationsConfigurationCategoryDialogComponent,
    RecommendationsConfigurationItemDialogComponent,
    RecommendationsConfigurationItemComponent,
    RecommendationsConfigurationSurveyRuleComponent,
  ],
  exports: [
    routedComponents,
    RecommendationCardComponent,
    RecommendationsComponent,
    RecommendationsConfigurationCategoryDialogComponent,
    RecommendationsConfigurationItemDialogComponent,
    RecommendationsConfigurationItemComponent,
    RecommendationsConfigurationSurveyRuleComponent,
  ],
  entryComponents: [
    RecommendationCardDialogComponent,
    RecommendationsConfigurationCategoryDialogComponent,
    RecommendationsConfigurationItemDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RecommendationModule { }
